const content = [require("./3/index").default];

export default content;
